import React, { lazy } from 'react';
export function TestimonialSection() {
  return <section className="w-full py-20 md:py-28 px-6 bg-beige text-center" data-id="element-192">
      <div className="max-w-4xl mx-auto" data-id="element-193">
        <h2 className="font-playfair text-4xl md:text-5xl text-dark mb-16" data-id="element-194">
          Historias reales de transformación
        </h2>
        <div className="flex justify-center" data-id="element-195">
          <img src="https://cdn.magicpatterns.com/uploads/x4Jbfgz6DWEMrCATRFuuK2/testimonios.jpg" alt="Testimonios de WhatsApp" loading="lazy" className="w-full max-w-2xl rounded-2xl shadow-xl shadow-dark/10 object-contain" data-id="element-196" />
        </div>
      </div>
    </section>;
}